<template>
    <div class="reports">
        <vue-good-table
        mode="remote"
        :columns="columns"
        :rows="rows"
        :sort-options="{
          enabled: true,
        }"
        :isLoading.sync="isLoading"
        styleClass="vgt-table bordered"
        :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <button type="button" class="btn btn-secondary" @click="configRole(props)">
              <font-awesome-icon :icon="['fa', 'sliders-h']"/>
            </button>
          </span>
        </template>
      </vue-good-table>
      <button @click="restore">Reataurar</button>
    </div>
  </template>
<script>
import axiosAdelaService from '@/axios/axiosAdelaService'

export default {
  components: {},
  data () {
    return {
      rows: [],
      columns: [
        {
          label: 'id_abono',
          field: 'id_abono'
        },
        {
          label: 'type',
          field: 'type'
        },
        {
          label: 'amount',
          field: 'amount'
        },
        {
          label: 'amount_use',
          field: 'amount_use'
        },
        {
          label: 'real_used',
          field: 'real_used'
        },
        {
          label: 'difference',
          field: 'difference'
        },
        {
          label: 'deberia',
          field: 'deberia'
        },
        {
          label: 'barcode',
          field: 'barcode'
        }
      ]
    }
  },
  methods: {
    async getReport () {
      try {
        const response = await axiosAdelaService.post('/valeReport')
        console.log('valeReport', response)
        this.rows = response.data.rows
        this.rows.forEach(el => {
          el.difference = el.amount - el.real_used
          const usado = el.amount - el.real_used
          el.deberia = usado < 0 ? el.amount : el.real_used.toFixed(2)
        })
      } catch (error) {
        console.log('error', error)
      }
    },
    async restore () {
      try {
        const payload = {
          data: this.rows
        }
        const response = await axiosAdelaService.post('/restoreVales', payload)
        console.log('valeReport', response)
      } catch (error) {
        console.log('error', error)
      }
    }
  },
  async mounted () {
    await this.getReport()
  }
}
</script>
